// extracted by mini-css-extract-plugin
export default {"link":"wvHIj","thumbnail":"c3xs3","iconLaunch":"TyDhB","noThumb":"gv7qR"};